import { Component } from 'react';
import './App.scss';
import ContextWrapper from "./components/ContextWrapper";
import userManager from './components/user-manager';
import UserLoginForm from './components/UserLoginForm';
import { onIOSWebApp, onSafari } from "./global/utils";
import { UTILITY_CSS_CLASSES } from "./global/constants";
import ViewsManager from './components/ViewsManager';


class App extends Component {
	constructor(props) {
		super(props)
		this.state = {
			preferences: {},					
		}
	}


	componentDidMount() {
		if ( userManager.userLoggedIn() ) {
			// get user preferences
		}		
	}

	renderComponents() {
		if ( !userManager.userLoggedIn() ) {
			return <UserLoginForm />;
		} else {
			return <ViewsManager/> 
		}
	}

	renderApp = () => {
		const iOSModifierClass = onIOSWebApp() ? UTILITY_CSS_CLASSES.onIOSWebApp : '';
		const safariModifierClass = onSafari() ? UTILITY_CSS_CLASSES.onSafari : '';

		return (
				 <ContextWrapper>
					<div className={ `App ${iOSModifierClass} ${safariModifierClass}` }>
						{ this.renderComponents() }						
							
					</div>
				</ContextWrapper>
		)
	}

	render() {
		return (
			this.renderApp()
		);
	}
}

export default App;